export const ITEMS_PER_COLUMN = 16;
export const COLUMN_WIDTH = 120;
export const COLUMN_GAP = 12;
export const PADDING_HORIZONTAL = COLUMN_GAP * 2;
export const MAX_COLUMNS_TO_SHOW = 3;

// Slightly reduced for mobile so 3 columns fit on a ~375px screen
export const MOBILE_COLUMN_WIDTH = 104;
export const MOBILE_COLUMN_GAP = 10;

export const FilterVisibility = {
  BASIC: "Basic",
  ADVANCED: "Advanced",
  HIDDEN: "Hidden",
  HIDDEN_QUICK_FILTER: "Hidden_Quick_Filter",
  SYSTEM_HIDDEN: "System_Hidden"
};
